import { Injectable } from '@angular/core';
import { AlertController, AlertOptions } from '@ionic/angular';
import { HashMap, TranslocoService } from '@jsverse/transloco';
import { environment } from 'src/environments/environment';
import { SelectOption } from '../forms';

@Injectable({
  providedIn: 'root',
})
export class I18nService {
  /**
   *
   */
  constructor(
    private alertCtrl: AlertController,
    private transloco: TranslocoService,
  ) {}

  /**
   * t(PaymentProviderEnum.WorldLine)
   */
  public mapEnum(enums: Enums, value: any) {
    return this.transloco.translate(`${enums}.${value}`);
  }

  public getOptions<T>(enums: Enums, values: any[], icons?: string[]): SelectOption<T>[] {
    return values.map((k, i) => ({ value: k, label: this.mapEnum(enums, k), icon: icons ? icons[i] : undefined }));
  }

  public translate(key: string, params?: HashMap) {
    return this.transloco.translate(key, params);
  }

  public translateError(appErrorKey: string, scope?: string): string {
    const key = scope ? `${scope}.${appErrorKey}` : `ERRORS.${appErrorKey}`;

    const result = this.transloco.translate(key);

    const isKeyValid = result !== computeMissingKey(key);

    if (isKeyValid) {
      return result;
    } else {
      if (scope) {
        // Not found, lets try without scope
        return this.translateError(appErrorKey);
      }

      // default message
      return this.transloco.translate('ERRORS.AnErrorOccured');
    }
  }

  public async checkSimpleAlert(mainKey: string): Promise<boolean> {
    const opt: AlertOptions = {
      header: this.translate(`${mainKey}.HEADER`),
      message: this.translate(`${mainKey}.MESSAGE`),
      buttons: [this.translate(`${mainKey}.NO`), { text: this.translate(`${mainKey}.YES`), role: 'confirm' }],
    };

    const alert = await this.alertCtrl.create(opt);
    await alert.present();
    const result = await alert.onDidDismiss();
    return result.role === 'confirm';
  }
}

export function computeMissingKey(key: string) {
  if (environment.enableAngularProdMode) return key;

  return `⚠️i18n(${key})⚠️`;
}

type Enums = 'PaymentProviderEnum' | 'ConviveTypeContrat' | 'DishInformationEnum' | 'ThemesEnum' | 'LikesFilterEnum' | 'RestaurantServiceValues';
